// extracted by mini-css-extract-plugin
export var active = "_d4-2";
export var recordingDot = "_d4-1";
export var recordingIndicator = "_d4-0";